<template>
    <div class="mb-6 mt-1 flex justify-left space-y-1 sm:space-x-2 lg:space-x-0 2xl:space-y-0 2xl:space-x-2">
            <button
            class="btn rounded-3xl px-6 w-auto sm:w-1/3 lg:w-full 2xl:w-auto"
            :class="isFilteredByAll ? 'btn--charcoalgray' : 'btn--charcoalgray__outline'"
            :disabled="isFilteredByAll"
            @click="setFilterShowAll">{{$t('methodEvaluationSearch.filterByAll')}}</button>

            <button
            class="btn rounded-3xl px-3 w-auto sm:w-1/3 lg:w-full 2xl:w-auto"
            :class="isFilteredByHealthAuthority ? 'btn--charcoalgray' : 'btn--charcoalgray__outline'"
            :disabled="isFilteredByHealthAuthority"
            @click="setFilterByHealthAuthority">{{$t('methodEvaluationSearch.filterByHealthAuthority')}}</button>

            <button
            class="btn rounded-3xl px-3.5 w-auto sm:w-1/3 lg:w-full 2xl:w-auto"
            :class="isFilteredByMunicipality ? 'btn--charcoalgray' : 'btn--charcoalgray__outline'"
            :disabled="isFilteredByMunicipality"
            @click="setFilterByMunicipality">{{$t('methodEvaluationSearch.filterByMunicipality')}}</button>
          </div>
</template>

<script>
  import { mapMutations } from 'vuex';

export default {
    name: 'Search Selected State Filter',
    emits: ['filterChanged'],
    props: {
        filterByHealthAuthority: Boolean,
        filterByMunicipality: Boolean,
    },
    computed: {
        isFilteredByHealthAuthority() {
            return this.filterByHealthAuthority && !this.filterByMunicipality;
        },
        isFilteredByMunicipality() {
            return !this.filterByHealthAuthority && this.filterByMunicipality;
        },
        isFilteredByAll() {
            return (this.filterByHealthAuthority && this.filterByMunicipality)
            || (!this.filterByHealthAuthority && !this.filterByMunicipality);
        },
    },
    methods: {
      ...mapMutations(['setPageNum', 'clearAll', 'clearSearch']),
      setFilterByHealthAuthority() {
            this.clearSearch();
            this.toggleFilters(true, false);
        },
        setFilterByMunicipality() {
            this.clearSearch();
            this.toggleFilters(false, true);
        },
        setFilterShowAll() {
            this.clearSearch();
            this.toggleFilters(false, false);
        },
      toggleFilters(healthAuthority, municipality) {
            this.setPageNum(1);
            this.$emit('update:filterByHealthAuthority', healthAuthority);
            this.$emit('update:filterByMunicipality', municipality);
            this.$emit('filterChanged');
        },
    },
};
</script>
